import { Component, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { Transaction } from '../../core/models/api.models';

@Component({
  selector: 'app-transaction-detail',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './transaction-detail.component.html',
  styleUrl: './transaction-detail.component.scss',
})
export class TransactionDetailComponent implements OnInit {
  private readonly api = inject(ApiService);
  private readonly route = inject(ActivatedRoute);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly tx = signal<Transaction | null>(null);

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      this.error.set('Missing transaction id');
      return;
    }
    this.load(id);
  }

  load(id: string): void {
    this.loading.set(true);
    this.error.set(null);
    this.api.getTransactionById(id).subscribe({
      next: (data) => {
        this.tx.set(data);
        this.loading.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load transaction');
        this.loading.set(false);
      },
    });
  }

  userLabel(tx: Transaction): string {
    const u = tx.user;
    if (!u) return tx.user_id != null ? String(tx.user_id) : '—';
    const name = [u.first_name, u.last_name].filter(Boolean).join(' ').trim();
    if (name && u.email) return `${name} · ${u.email}`;
    return u.email || name || String(u.id);
  }
}
